import { getDataIdGenerator } from '../../../../shared/utils/dataId';
import { Checkbox } from '../../../../checkbox/Checkbox';
import { ObjectField, ObjectFieldStatus } from '../../interfaces/object-field';
import { Radio } from '../../../../radio/Radio';
import { Switch } from '../../../../switch/Switch';
import { ObjectFieldCellType, ObjectFieldColumnConfig } from '../../interfaces/object-field-header';
import { Tooltip } from '../../../../tooltip/Tooltip';

interface FieldCellProps {
  index: number;
  fieldDetails: ObjectField;
  handleToggleCheckedState: (fieldDetails: ObjectField, included: boolean) => void;
  columnConfig: ObjectFieldColumnConfig;
  isViewMode?: boolean;
  updateFieldProperty: (field: ObjectField, key: string, value: unknown) => void;
}

export function FieldCell({
  index,
  fieldDetails,
  handleToggleCheckedState,
  columnConfig,
  isViewMode,
  updateFieldProperty
}: FieldCellProps) {
  const dataIdGenerator = getDataIdGenerator(`row-${index}`);

  const cellKey = columnConfig.name;
  const cell = fieldDetails.cells[cellKey];
  const cellType = columnConfig.type;

  return (
    <div className='center-flex-row justify-center w-100'>
      {cellType === ObjectFieldCellType.CHECKBOX ? (
        <Tooltip
          dataId={dataIdGenerator('')}
          title={cell.statusReason}
          disabled={isViewMode || cell.isEditable}
        >
          <div className='d-flex'>
            <Checkbox
              dataId={dataIdGenerator('')}
              value={cell.value}
              checked={cell.value as boolean}
              disabled={isViewMode || !cell.isEditable}
              onChange={() => {
                updateFieldProperty(fieldDetails, cellKey, !cell.value);
              }}
            />
          </div>
        </Tooltip>
      ) : null}

      {cellType === ObjectFieldCellType.RADIO ? (
        <Tooltip dataId={dataIdGenerator('')} title={cell.statusReason} disabled={cell.isEditable}>
          <div className='d-flex'>
            <Radio
              dataId={dataIdGenerator('')}
              value={cell.value}
              checked={cell.value as boolean}
              disabled={isViewMode || !cell.isEditable}
              onChange={() => {
                updateFieldProperty(fieldDetails, cellKey, !cell.value);
              }}
            />
          </div>
        </Tooltip>
      ) : null}

      {cellType === ObjectFieldCellType.TOGGLE ? (
        <Tooltip dataId={dataIdGenerator('')} title={cell.statusReason} disabled={cell.isEditable}>
          <div className='d-flex'>
            <Switch
              dataId={dataIdGenerator('')}
              checked={cell.value as boolean}
              disabled={isViewMode || !cell.isEditable}
              onChange={() => {
                updateFieldProperty(fieldDetails, cellKey, !cell.value);
              }}
            />
          </div>
        </Tooltip>
      ) : null}

      {cellType === ObjectFieldCellType.TEXT ? (
        <div className='w-100 center-flex-row'>
          {index === 0 ? (
            <Tooltip
              dataId={dataIdGenerator('')}
              title={fieldDetails.status.statusReason}
              disabled={isViewMode || !fieldDetails.status.isEditable}
            >
              <div className='d-flex mr-2'>
                <Checkbox
                  dataId={dataIdGenerator('')}
                  disabled={isViewMode || !fieldDetails.status.isEditable}
                  checked={fieldDetails.status.value === ObjectFieldStatus.ACTIVE}
                  onChange={() =>
                    handleToggleCheckedState(
                      fieldDetails,
                      fieldDetails.status.value !== ObjectFieldStatus.ACTIVE
                    )
                  }
                />
              </div>
            </Tooltip>
          ) : null}

          <Tooltip dataId='value' title={cell.value as string} enableOnTextOverflow>
            <div className='text-ellipsis' style={{ maxWidth: '75%' }}>
              {cell.value as string}
            </div>
          </Tooltip>

          <Tooltip dataId='helper-text' title={cell.helperText} enableOnTextOverflow>
            <span
              style={{ maxWidth: '20%' }}
              className='text-secondary text-ellipsis text-caption-1 ml-1 text-lowercase'
            >
              {cell.helperText}
            </span>
          </Tooltip>
        </div>
      ) : null}
    </div>
  );
}
